export const keycloakEnvironment = {
    KEYCLOAK_URL: 'https://sso-16-hom.procempa.com.br/auth',
    KEYCLOAK_REALM: 'geo',
    KEYCLOAK_CLIENT: 'coletor-poa'
};